// --------------------------------------------------
// Image Imports
// --------------------------------------------------
import commerceStatsImg from '@/assets/images/explore/commerce-stats.svg'
import marketingStatsImg from '@/assets/images/explore/marketing-stats.svg'
import merchandisingStatsImg from '@/assets/images/explore/merchandising-stats.svg'
import serviceStatsImg from '@/assets/images/explore/service-stats.svg'
import retailStatsImg from '@/assets/images/explore/retail-stats.svg'
import netoStatsImg from '@/assets/images/explore/neto-stats.svg'

// --------------------------------------------------
// Types
// --------------------------------------------------
export interface ProductFeature {
  title: string
}

export interface ProductAction {
  title: string
  link: string
}

export interface ExploreProduct {
  title: string
  description: string
  image: string
  features: ProductFeature[]
  action: ProductAction
}

// --------------------------------------------------
// Constants
// --------------------------------------------------
export const EXPLORE_MORE_PRODUCTS: ExploreProduct[] = [
  {
    title: 'Commerce Cloud',
    description: 'Everything you need to build and grow your online store.',
    image: commerceStatsImg,
    features: [
      { title: 'Promotion engine' },
      { title: 'Storefront theme builder' },
      { title: 'Inventory optimization' }
    ],
    action: {
      title: 'LEARN MORE',
      link: 'https://maropost.com/sign-up-for-commerce-cloud'
    }
  },
  {
    title: 'Marketing Cloud',
    description: 'Deliver personalized marketing campaigns automatically.',
    image: marketingStatsImg,
    features: [
      { title: 'Customer segmentation' },
      { title: 'Acquisition form builder' },
      { title: 'Campaign management' }
    ],
    action: {
      title: 'LEARN MORE',
      link: 'https://maropost.com/platform/marketing-cloud'
    }
  },
  {
    title: 'Merchandising Cloud',
    description: 'Supercharge your revenue with smarter search and discovery.',
    image: merchandisingStatsImg,
    features: [
      { title: 'Product Recommendations' },
      { title: 'Insights and Analytics' },
      { title: 'Unified Customer Profile' }
    ],
    action: {
      title: 'LEARN MORE',
      link: 'https://maropost.com/platform/merchandising-cloud'
    }
  },
  {
    title: 'Service Cloud',
    description: 'Give service agents more ways to win',
    image: serviceStatsImg,
    features: [
      { title: 'Artificial Intelligence Chatbot' },
      { title: 'Ticket Management' },
      { title: 'Engage across brands' }
    ],
    action: {
      title: 'LEARN MORE',
      link: 'https://maropost.com/platform/service-cloud'
    }
  },
  {
    title: 'Retail Express',
    description: 'Unify online & in-store operations point of sales.',
    image: retailStatsImg,
    features: [
      { title: 'Real-time data sync' },
      { title: 'Optimal inventory management' },
      { title: 'Streamlined order fulfillment' }
    ],
    action: {
      title: 'LEARN MORE',
      link: 'https://maropost.com/sign-up-for-retail-cloud'
    }
  },
  {
    title: 'Neto',
    description: "Neto's ecommerce platform for online retailers",
    image: netoStatsImg,
    features: [
      { title: 'B2B Wholesale' },
      { title: 'Multi-channel e-commerce' },
      { title: 'Financial Integrations' }
    ],
    action: {
      title: 'LEARN MORE',
      link: 'https://netohq.com'
    }
  }
]

